import { h } from '@logicflow/core';
import { RectNode, RectNodeModel } from '@logicflow/core';

// 平行四边形节点（过程）
export class PolygonNode extends RectNode {
  // 重写getText方法来支持多行文本显示
  getText() {
    const { model } = this.props;
    const { text } = model;

    if (!text || !text.value) {
      return null;
    }

    // 处理多行文本
    const textLines = text.value.split('\n');
    const lineHeight = 16; // 行高
    const totalHeight = (textLines.length - 1) * lineHeight;
    
    // 如果只有一行文本，使用父类的默认渲染
    if (textLines.length === 1) {
      return super.getText();
    }

    // 多行文本渲染
    return h(
      'g',
      {
        className: 'lf-node-text-group',
      },
      textLines.map((line, index) => 
        h(
          'text',
          {
            x: text.x,
            y: text.y - totalHeight / 2 + index * lineHeight,
            fill: '#000000',
            textAnchor: 'middle',
            dominantBaseline: 'middle',
            style: {
              fontSize: 14,
              userSelect: 'none',
            },
            key: `line-${index}`,
          },
          line
        )
      )
    );
  }

  getShape() {
    const { model } = this.props;
    let { x, y, width, height } = model;

    // 确保所有数值都是有效的，防止NaN导致SVG渲染错误
    x = Number(x) || 0;
    y = Number(y) || 0;
    width = Number(width) || 100;
    height = Number(height) || 60;

    // 验证数值的有效性
    if (
      isNaN(x) ||
      isNaN(y) ||
      isNaN(width) ||
      isNaN(height) ||
      !isFinite(x) ||
      !isFinite(y) ||
      !isFinite(width) ||
      !isFinite(height)
    ) {
      console.error('PolygonNode SVG属性包含无效值:', { x, y, width, height });
      x = 0;
      y = 0;
      width = 100;
      height = 60;
    }

    // 绘制椭圆形状，与工具条图标保持一致
    return h('g', {}, [
      h('ellipse', {
        cx: x,
        cy: y,
        rx: width / 2,
        ry: height / 2,
        fill: '#ffffff',
        stroke: '#3BC3FF',
        strokeWidth: 2,
      }),
    ]);
  }
}

export class PolygonNodeModel extends RectNodeModel {
  initNodeData(data: any) {
    super.initNodeData(data);
    this.width = 100;
    this.height = 60;
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    style.fill = '#ffffff';
    style.stroke = '#3BC3FF';
    return style;
  }

  getTextStyle() {
    const style = super.getTextStyle();
    return {
      ...style,
      color: '#000000',
      fontSize: 14,
      // fontWeight: 'bold',
      // overflowMode: 'default',
      // lineHeight: 1.2,
    };
  }
}
